import moment from "moment"
import { v4 as uuidv4 } from 'uuid';

const SET_RESERVA_FORM = (state, payload) => { state.reservaForm = payload }
const RESET_RESERVA_FORM = (state) => {
    state.reservaForm = {
        atrativo: {},
        atrativo_id: '',
        name: '',
        surname: 'Janoo',
        cpf_cnpj: '01234567890',
        phoneFlag: '55',
        phone: '',
        payment_method: '',
        email: '',
        date: moment().format('YYYY-MM-DD'),
        time: '',
        hash: uuidv4().toUpperCase(),
        confirm_term: false,
        payLater: false,
        free_booking: false,
        booking_name: '',
        booking_slug: '',
        tickets: [],
        address: {
            street: 'Rua teste',
            number: '0',
            complement: '',
            neighborhood: 'Teste',
            zipcode: '00000000',
            country: 'Brasil',
            state: 'BA',
            city: 'Lençóis',
        },
    }
}

const RESET_FORM_STANDART_DATA = (state, payload) => {
    state.reservaForm.date = moment().format('YYYY-MM-DD')
    state.reservaForm.booking_name = payload.atrativo.special_prices[0][0]['name']
    state.reservaForm.booking_slug = payload.atrativo.special_prices[0][0]['slug']
    state.reservaForm.payment_method = ''
    state.reservaForm.phone = ''
    state.reservaForm.phoneFlag = '55'
    state.reservaForm.email = ''
    state.reservaForm.name = ''
    state.reservaForm.hash = uuidv4().toUpperCase()
    state.reservaForm.confirm_term = false,
    state.reservaForm.free_booking = false,
    state.reservaForm.payLater = false,
    state.reservaForm.tickets = payload.tickets,
    Object.values(payload.tickets).forEach(item => {
        if(item.label.toUpperCase() == 'INTEIRA'){
            item.quantity = 1
        }

        if(item.label.toUpperCase() != 'INTEIRA'){
            item.quantity = 0
        }
    })
}

const SET_DIAL_CODES_ARRAY = (state, payload) => { state.dialCodesArray = payload }
const RESET_DIAL_CODES_ARRAY = (state) => { state.dialCodesArray = [] }

const SET_COUNTRIES_ARRAY = (state, payload) => { state.countriesArray = payload }
const RESET_COUNTRIES_ARRAY = (state) => { state.countriesArray = [] }

const SET_STATES_ARRAY = (state, payload) => { state.statesArray = payload }
const RESET_STATES_ARRAY = (state) => { state.statesArray = [] }

const SET_CITIES_ARRAY = (state, payload) => { state.citiesArray = payload }
const RESET_CITIES_ARRAY = (state) => { state.citiesArray = [] }

const SET_MP_CALLBACK_URL_MP = (state, payload) => { state.callbackUrlMP = payload }
const RESET_MP_CALLBACK_URL_MP = (state) => { state.callbackUrlMP = "" }

const SET_EXPRESSBOOKING_RESPONSE = (state, payload) => { state.expressBookingResponse = payload }
const RESET_EXPRESSBOOKING_RESPONSE = (state) => { state.expressBookingResponse = "" }

const SET_PLACE_PUBLIC_DATA = (state, payload) => { state.place_public_data = payload; }
const RESET_PLACE_PUBLIC_DATA = (state) => {
    state.place_public_data = {
        place: {
            name: '',
            xfields: { Logotipo: { label: {} } }
        }
    }
}

const SET_TERMS_CONDITIONS = (state, payload) => { state.terms_conditions = payload; }
const RESET_TERMS_CONDITIONS = (state) => { state.terms_conditions = "" }

const SET_WS_PAYMENT_STATUS = (state, payload) => { state.wsStatusPaymentMP = payload }
const RESET_WS_PAYMENT_STATUS = (state) => { state.wsStatusPaymentMP = "" }

export default {
    SET_RESERVA_FORM,
    RESET_RESERVA_FORM,

    RESET_FORM_STANDART_DATA,

    SET_DIAL_CODES_ARRAY,
    RESET_DIAL_CODES_ARRAY,

    SET_COUNTRIES_ARRAY,
    RESET_COUNTRIES_ARRAY,

    SET_STATES_ARRAY,
    RESET_STATES_ARRAY,

    SET_CITIES_ARRAY,
    RESET_CITIES_ARRAY,

    SET_PLACE_PUBLIC_DATA,
    RESET_PLACE_PUBLIC_DATA,

    SET_TERMS_CONDITIONS,
    RESET_TERMS_CONDITIONS,

    SET_MP_CALLBACK_URL_MP,
    RESET_MP_CALLBACK_URL_MP,

    SET_EXPRESSBOOKING_RESPONSE,
    RESET_EXPRESSBOOKING_RESPONSE,

    SET_WS_PAYMENT_STATUS,
    RESET_WS_PAYMENT_STATUS,
}
